import { IconButton } from "rsuite";
import "./IconButton.css";

const SCIconButton = (props) => {
  return (
    <IconButton
      {...props}
      className={`sc-icon-btn ${
        (props.appearance == "primary" && "sc-icon-btn sc-icon-btn--primary") ||
        ""
      } ${props.className || ""}`}
    >
      {props.children}
    </IconButton>
  );
};

export default SCIconButton;
